import { useMemo, useState } from "react";
import { useUpdateNeedMutation, type NeedDto, type NeedPatchDto } from "../../../autogen/bff-api";
import { useApiErrorEditorConfig, useCreateEditor } from "../../../common/editing/save-coordinator";
import { NeedForm } from "./NeedForm";
import { NeedSubmitted } from "./NeedSubmitted";

interface Props {
  needId: string;
  need: NeedDto;
  refetch: () => void;
}

export const NeedEditorRoot = ({ needId, need, refetch }: Props) => {
  const editorErrorConfig = useApiErrorEditorConfig();
  const [updateNeed] = useUpdateNeedMutation();
  const [submitted, setSubmitted] = useState(false);

  const config = useMemo(
    () => ({
      initialState: need,
      save: async (fields: Partial<NeedPatchDto>): Promise<NeedDto> =>
        await updateNeed({ needId, needPatchDto: fields as NeedPatchDto }).unwrap(),
      ...editorErrorConfig,
    }),
    [need, needId, updateNeed, editorErrorConfig],
  );

  useCreateEditor<NeedDto, NeedPatchDto>(needId, config);

  if (submitted) return <NeedSubmitted />;

  return <NeedForm needId={needId} need={need} refetch={refetch} onSubmitted={() => setSubmitted(true)} />;
};
